import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, first, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IaAssistService {
  private readonly http = inject(HttpClient);

  private buildHeaders(token?: string, skipAuthLogout = false): HttpHeaders {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization-SeniorX'] = token;
    }

    if (skipAuthLogout) {
      // Prevent global error interceptor from triggering a full auth logout
      headers['X-Skip-Auth-Logout'] = '1';
    }

    return new HttpHeaders(headers);
  }

  authenticationIa() {
    const payload = {};
    const headers = this.buildHeaders(undefined, true).set('X-Skip-Error-Snackbar', '1');
    return this.http
      .post<any>(`${environment.API_INTEGRADOR}/seniorx/loginWithKey`, payload, { headers })
      .pipe(
        first(),
        catchError((error: HttpErrorResponse) => {
          console.error('authenticationIa error', error);
          return throwError(() => error);
        })
      );
  }

  getThreads(token: string, language?: string) {
    let headers = this.buildHeaders(token, true);
    let params = new HttpParams();

    if (language) {
      headers = headers
        .set('Accept-Language', language)
        .set('X-Language', language);

      params = params
        .set('language', language)
        .set('lang', language)
        .set('locale', language);
    }

    return this.http
      .get<any>(`${environment.INTEGRACAO_SENIORX}/api/latest/threads`, { headers, params })
      .pipe(
        first(),
        catchError((error: HttpErrorResponse) => {
          console.error('Failed to fetch threads:', error);
          return throwError(() => error);
        })
      );
  }

  createThread(token: string, obj: any) {
    const headers = this.buildHeaders(token, true);
    return this.http
      .post<any>(`${environment.INTEGRACAO_SENIORX}/api/latest/threads`, obj, { headers })
      .pipe(
        first(),
        catchError((error: HttpErrorResponse) => {
          console.error('Failed to create thread:', error);
          return throwError(() => error);
        })
      );
  }

  searchThreadprocessing(runId: any, threadId: any, token: any) {
    const headers = this.buildHeaders(token, true);
    return this.http
      .get<any>(`${environment.INTEGRACAO_SENIORX}/api/latest/threads/${threadId}/runs/${runId}`, { headers })
      .pipe(
        first(),
        catchError((error: HttpErrorResponse) => {
          console.error('Failed to fetch thread run:', error);
          return throwError(() => error);
        })
      );
  }

  threadMessageSearch(threadId: any, token: any) {
    const headers = this.buildHeaders(token, true);
    return this.http
      .get<any>(`${environment.INTEGRACAO_SENIORX}/api/latest/threads/${threadId}/messages`, { headers })
      .pipe(
        first(),
        catchError((error: HttpErrorResponse) => {
          console.error('Failed to fetch thread messages:', error);
          return throwError(() => error);
        })
      );
  }

  getInstance(token: any) {
    const headers = this.buildHeaders(token);
    return this.http
      .get<any>(`${environment.INTEGRACAO_SENIORX}/api/latest/agents/instances`, { headers })
      .pipe(
        first(),
        catchError((error: HttpErrorResponse) => {
          console.error('Failed to validate instance:', error);
          return throwError(() => error);
        })
      );
  }

  getCategoriesAndQuestions() {
    return this.http.get<any>(`${environment.API_FILTER}/categoria`).pipe(
      first(),
      catchError((error: HttpErrorResponse) => {
        console.error('Failed to fetch categories:', error);
        return throwError(() => error);
      })
    );
  }
}
